module.exports = __webpack_public_path__ + "static/media/Belmont2.ca948448.png";